/*
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 *
 * Copyright: 2023 by Idemia Identity & Security USA LLC. All rights reserved.
 * License: In accordance  Idemia I&S USA LLC's license agreement.
 * Code Classification: GOVERNMENT
 *
 * Classification Person: Nadim Bakizada nadim.bakizada@us.idemia.com
 * Classification Reason: Software not specific to any U.S. Government Entity
 * Classification Date: 2023
 *
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 */

import React from "react";
import { useMUITheme } from "theme/ThemeProvider";
import { AppBar, IconButton, Grid, Tooltip } from '@mui/material';
import DarkMode from '@mui/icons-material/Brightness4';
import LightMode from '@mui/icons-material/Brightness5';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const state = process.env.REACT_APP_CONFIG_STATE;
let loginGuide: string;
try {
  loginGuide = require(`../../assets/pdfs/first_time_login_${state}_user_guide.pdf`);
} catch {
  loginGuide = require(`../../assets/pdfs/login_user_guide.pdf`);
}

export const LoginNavbar: React.FC = () => {
  const { mode, toggleTheme } = useMUITheme();
  const isDark = mode === "dark";
  console.log('debug theme', mode)

  return (
    <>
      <AppBar position='static' style={{ backgroundColor: 'inherit' }} elevation={0}>
        <Grid container justifyContent='flex-end' display='flex' pr='1rem' pt='1rem'>
          <Tooltip title="Toggle Theme">
            <IconButton onClick={toggleTheme} aria-label="Toggle theme">
              {isDark ? <DarkMode data-testid="dark-theme-button" /> : <LightMode data-testid="light-theme-button" />}
            </IconButton>
          </Tooltip>
          <a target="_blank" rel="noopener noreferrer" href={loginGuide} aria-label='help button'>
            <Tooltip title="Help">
              <IconButton aria-label='Help button'>
                <HelpOutlineIcon data-testid="help-button" />
              </IconButton>
            </Tooltip>
          </a>
        </Grid>
      </AppBar>
    </>
  );
};
